var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client/react';
import useAccount from 'shared/domains/users/hooks/useAccount';
import { CreateFileSystemAclsDocument } from './CreateFileSystemAclsMutation.gql';
export function useCreateFileSystemAcls(options) {
    const { entryId = '' } = options;
    const [mutate, { loading, error }] = useMutation(CreateFileSystemAclsDocument);
    const account = useAccount();
    const { companyId } = account.data;
    const handleMutate = (values) => __awaiter(this, void 0, void 0, function* () {
        return mutate({
            variables: {
                userAclsToUpdate: values.userAcls.toUpdate.map((acl) => ({
                    entryId,
                    id: acl.id || '',
                    actions: acl.actions,
                })),
                userAclsToCreate: values.userAcls.toCreate.map((acl) => (Object.assign(Object.assign({}, acl), { companyId, entryId }))),
                userAclsToDelete: values.userAcls.toDelete.map((acl) => acl.id || ''),
                teamAclsToUpdate: values.teamAcls.toUpdate.map((acl) => ({
                    id: acl.id || '',
                    actions: acl.actions,
                    entryId,
                })),
                teamAclsToCreate: values.teamAcls.toCreate.map((acl) => (Object.assign(Object.assign({}, acl), { companyId, entryId }))),
                teamAclsToDelete: values.teamAcls.toDelete.map((acl) => acl.id || ''),
                hasUserAclsToUpdate: values.userAcls.toUpdate.length > 0,
                hasUserAclsToCreate: values.userAcls.toCreate.length > 0,
                hasTeamAclsToUpdate: values.teamAcls.toUpdate.length > 0,
                hasTeamAclsToCreate: values.teamAcls.toCreate.length > 0,
                hasUserAclsToDelete: values.userAcls.toDelete.length > 0,
                hasTeamAclsToDelete: values.teamAcls.toDelete.length > 0,
            },
            update(cache, { data }) {
                const { createFileSystemAcls, createFileSystemTeamAcls, updateFileSystemAcls, updateFileSystemTeamAcls, deleteFileSystemAcls, deleteFileSystemTeamAcls, } = data || {};
                if (createFileSystemAcls) {
                    createFileSystemAcls.forEach((acl) => {
                        cache.modify({
                            id: cache.identify({ id: entryId, __typename: 'FileSystemDocument' }),
                            fields: {
                                acls(existing = [], { toReference }) {
                                    const newReferences = [toReference(acl, true)];
                                    return [...existing, ...newReferences];
                                },
                            },
                        });
                    });
                }
                if (createFileSystemTeamAcls) {
                    createFileSystemTeamAcls.forEach((acl) => {
                        cache.modify({
                            id: cache.identify({ id: entryId, __typename: 'FileSystemDocument' }),
                            fields: {
                                teamAcls(existing = [], { toReference }) {
                                    const newReferences = [toReference(acl, true)];
                                    return [...existing, ...newReferences];
                                },
                            },
                        });
                    });
                }
                if (updateFileSystemAcls === null || updateFileSystemAcls === void 0 ? void 0 : updateFileSystemAcls.length) {
                    updateFileSystemAcls.forEach((acl) => {
                        cache.modify({
                            id: cache.identify({ id: acl.id, __typename: 'FileSystemAcl' }),
                            fields: {
                                actions: () => acl.actions,
                            },
                        });
                    });
                }
                if (updateFileSystemTeamAcls === null || updateFileSystemTeamAcls === void 0 ? void 0 : updateFileSystemTeamAcls.length) {
                    updateFileSystemTeamAcls.forEach((acl) => {
                        cache.modify({
                            id: cache.identify({ id: acl.id, __typename: 'FileSystemTeamAcl' }),
                            fields: {
                                actions: () => acl.actions,
                            },
                        });
                    });
                }
                if (deleteFileSystemAcls === null || deleteFileSystemAcls === void 0 ? void 0 : deleteFileSystemAcls.affected) {
                    values.userAcls.toDelete.forEach((acl) => {
                        cache.modify({
                            id: cache.identify({ id: acl.id, __typename: 'FileSystemAcl' }),
                            fields(_, { DELETE }) {
                                return DELETE;
                            },
                        });
                    });
                }
                if (deleteFileSystemTeamAcls === null || deleteFileSystemTeamAcls === void 0 ? void 0 : deleteFileSystemTeamAcls.affected) {
                    values.teamAcls.toDelete.forEach((acl) => {
                        cache.modify({
                            id: cache.identify({ id: acl.id, __typename: 'FileSystemTeamAcl' }),
                            fields(_, { DELETE }) {
                                return DELETE;
                            },
                        });
                    });
                }
            },
        });
    });
    return { createFileSystemAcls: handleMutate, loading, error };
}
